import { defineComponent as _defineComponent } from 'vue'
import ContainerCenter from '@/components/ui/ContainerCenter.vue'
import Logo from '@/components/ui/Logo.vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'Landing',
  setup(__props) {


return { __sfc: true,ContainerCenter, Logo }
}

})